document.addEventListener('DOMContentLoaded', () => {
  console.log('Mobile Menu JS Loaded'); // Log when script starts
  const hamburgerButton = document.querySelector('.navbar-hamburger');
  const closeButton = document.querySelector('.mobile-menu-close');
  const mobileMenuDrawer = document.getElementById('mobile-menu-drawer');

  if (!hamburgerButton) console.error('Hamburger button not found!');
  if (!closeButton) console.error('Close button not found!');
  if (!mobileMenuDrawer) console.error('Mobile menu drawer not found!');

  if (hamburgerButton && mobileMenuDrawer) {
    console.log('Attaching listener to hamburger button');
    hamburgerButton.addEventListener('click', () => {
      console.log('Hamburger button clicked!'); // Log click
      mobileMenuDrawer.classList.add('mobile-menu--open');
      // Optionally: trap focus within the drawer
    });
  }

  if (closeButton && mobileMenuDrawer) {
    console.log('Attaching listener to close button');
    closeButton.addEventListener('click', () => {
      console.log('Close button clicked!'); // Log click
      mobileMenuDrawer.classList.remove('mobile-menu--open');
      // Optionally: return focus to the hamburger button
    });
  }

  // Optional: Close drawer if clicking outside of it
  // document.addEventListener('click', (event) => {
  //   if (mobileMenuDrawer.classList.contains('mobile-menu--open') && 
  //       !mobileMenuDrawer.contains(event.target) && 
  //       !hamburgerButton.contains(event.target)) {
  //     mobileMenuDrawer.classList.remove('mobile-menu--open');
  //   }
  // });
}); 